import RootPage from './Root';

export default RootPage;
